import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { push, goBack } from "connected-react-router";
import { withRouter } from "react-router-dom";

import UserActioner from "services/user/actioner";
import UserUtils from "services/user/utils";

import Button from "components/Button";
import TextField from "components/TextField";

import paths from "routes/paths";
import ParkkiTheme from "themes/ParkkiTheme";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  inputContainer: {
    marginBottom: "16px",
    width: "100%",
  },
  textFieldContainer: {
    marginTop: "8px",
  },
  forgotPasswordContainer: {
    flex: 1,
    textAlign: "right",
    color: "white",
    opacity: "0.85",
    cursor: "pointer",
  },
  keepLoggedInContainer: {
    flex: 1,
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  cancelButton: {
    backgroundColor: ParkkiTheme.colors.turquoise3,
  },
};

class ForgotPasswordFormComponent extends React.Component {
  state = {
    email: "",
    emailValid: false,
    error: {
      email: "",
    },
  };

  askForNewPassword = () => {
    if (!this.state.emailValid) {
      this.setState({
        error: { ...this.state.error, email: "Email invalide" },
      });
      return;
    }

    this.props.askForNewPassword(this.state.email).then(() => {
      this.props.push(paths.front.login);
    });
  };

  handleCancel = () => {
    this.props.goBack();
  };

  render() {
    const { intl } = this.props;

    return (
      <div style={styles.container}>
        <div style={styles.inputContainer}>
          <div style={styles.textFieldContainer}>
            <TextField
              label={intl.messages["loginScene.login.userNameEmail"]}
              helperText={this.state.error.email}
              error={this.state.error.email !== ""}
              onChange={(e) =>
                this.setState({
                  email: e.target.value,
                  emailValid: UserUtils.isEmailValid(e.target.value),
                })
              }
              value={this.state.email}
              fullWidth
            />
          </div>
        </div>
        <div style={styles.buttonsContainer}>
          <Button
            color="secondary"
            style={{ marginRight: "10px" }}
            label={
              intl.messages["loginScene.forgotPassword.cancelForgotPassword"]
            }
            onClick={this.handleCancel}
          />
          <Button
            disabled={!this.state.emailValid}
            label={
              intl.messages["loginScene.forgotPassword.validateForgotPassword"]
            }
            onClick={this.askForNewPassword}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "15px",
            width: "100%",
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  askForNewPassword: (data) => {
    return dispatch(UserActioner.askForNewPassword(data));
  },
  push: (route) => dispatch(push(route)),
  goBack: () => dispatch(goBack()),
});

ForgotPasswordFormComponent.defaultProps = {};

ForgotPasswordFormComponent.propTypes = {
  askForNewPassword: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(ForgotPasswordFormComponent))
);
